import { Skeleton } from '@zorro/design-system/v2/Skeleton';
import { Grid, Stack } from '@zorro/web/design-system';

export const EmployeeLayoutSidebarHeaderSkeleton = () => {
  return (
    <Stack
      bg="zorroWhite.0"
      px="md"
      py="xl"
      mb="lg"
      gap={0}
      top={0}
      pos="sticky"
      style={{ borderRadius: 'var(--mantine-radius-lg)', zIndex: 5 }}
    >
      <Grid gap="lg">
        <Grid.Col span={10}>
          <Skeleton h={16} mb="xs" />
        </Grid.Col>
        <Grid.Col span={2}>
          <Skeleton h={16} w={16} />
        </Grid.Col>
      </Grid>
      <Stack gap="xs" pb="md">
        <Skeleton h={12} w="60%" />
        <Grid>
          <Grid.Col span={4}>
            <Skeleton h={12} w={80} />
          </Grid.Col>
          <Grid.Col span={4} offset={4}>
            <Skeleton h={12} w={100} />
          </Grid.Col>
        </Grid>
        <Grid>
          <Grid.Col span={3}>
            <Skeleton h={12} w={100} />
          </Grid.Col>
          <Grid.Col span={3} offset={5}>
            <Skeleton h={12} w={70} />
          </Grid.Col>
        </Grid>
        <Grid>
          <Grid.Col span={3}>
            <Skeleton h={12} w={100} />
          </Grid.Col>
          <Grid.Col span={3} offset={5}>
            <Skeleton h={12} w={70} />
          </Grid.Col>
        </Grid>
        <Grid>
          <Grid.Col span={3}>
            <Skeleton h={12} w={100} />
          </Grid.Col>
          <Grid.Col span={3} offset={5}>
            <Skeleton h={12} w={70} />
          </Grid.Col>
        </Grid>
      </Stack>
      <Skeleton h={36} w="100%" />
      <Skeleton h={36} w="100%" mt="xl" />
    </Stack>
  );
};
